import { FC } from 'react';
import { GaugeLabels, GaugeSvg } from './components';
import { GaugeContainer, GaugeSvgContainer } from './styled';
import { GaugeProps } from './types';

export const Gauge: FC<GaugeProps> = ({ label, value }) => {
  return (
    <GaugeContainer>
      <GaugeSvgContainer>
        <GaugeSvg value={value} />
      </GaugeSvgContainer>
      <GaugeLabels label={label} value={value} />
    </GaugeContainer>
  );
};
